import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { PruHttpService } from '../services/pru-http.service';
import * as Rx from 'rxjs/Rx';

@Injectable({
  providedIn: "root"
})
export class PrucarouselService {
  constructor(private PruHTTP: PruHttpService) {}

  getCarouselData(serviceURL: string): Observable<any> {
    return this.PruHTTP.get(serviceURL, "PruCarouselService");
  }
}
